/* @flow */

//----------------------------------------------------------------------//
// GLOBAL IMPORTS
//----------------------------------------------------------------------//

import * as React from 'react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';

//----------------------------------------------------------------------//
// MATERIAL UI
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';
import NavigationService from 'services/NavigationService';

//----------------------------------------------------------------------//
// REACT COMPONENT
//----------------------------------------------------------------------//

type TypeProps = {|
  t: Function,
  title: string,
  assetsCount: number,
  companyId?: string,
  locationId?: string,
  countryId?: string,
|};

const CompanyAssets: Function = ({
  t,
  title,
  companyId,
  countryId,
  locationId,
  assetsCount,
}: TypeProps): ?React.Element<*> => {
  if (!assetsCount) {
    return null;
  }

  const filters = [
    ...(companyId ? [{ key: 'company_id', values: [companyId] }] : []),
    ...(locationId ? [{ key: 'location_id', values: [locationId] }] : []),
    ...(countryId ? [{ key: 'country_id', values: [countryId] }] : []),
  ];

  const url = NavigationService.formulateReportViewUri(`/assets`, {
    page: 1,
    filters,
  });

  return (
    <section>
      <h3>{title}</h3>
      <table className="layout-table large-first-col">
        <tbody>
          <tr>
            <td style={{ width: '130px' }}>{t('general:asset_plural')}</td>
            <td className="layout-flex">
              <div>
                <span>{assetsCount}</span>
                <Button
                  color="primary"
                  variant="contained"
                  className="layout-button"
                  to={url}
                  component={Link}
                >
                  {t('general:actions.view_asset', {
                    count: assetsCount,
                  })}
                </Button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  );
};

export default translate()(CompanyAssets);
